import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";

const heroSlides = [
  {
    eyebrow: "Plateforme de gestion scolaire",
    title: "Une école mieux organisée, des parents mieux informés.",
    copy:
      "EviveSoma centralise le suivi pédagogique, les paiements, les communications et les données administratives dans une interface simple, moderne et sécurisée.",
    image: "assets/img/hero/hero-img.png",
    imageAlt: "Tableau de bord scolaire EviveSoma",
    grayscale: true,
    stat: "24/7",
    statLabel: "Suivi disponible",
    points: ["Suivi des élèves", "Paiements scolaires", "Communication parent-école"],
    locations: ["Kinshasa", "Lubumbashi", "Goma", "Bukavu"],
  },
  {
    eyebrow: "Parents et élèves",
    title: "Les familles suivent les notes, les frais et la présence sans se déplacer.",
    copy:
      "Depuis un téléphone, un parent peut consulter les bulletins, vérifier les paiements, recevoir les annonces et accompagner chaque enfant au quotidien.",
    image: "assets/img/marketing/marketing01.png",
    imageAlt: "Parent consultant les informations scolaires",
    stat: "360",
    statLabel: "Vue complète",
    points: ["Bulletins par période", "Reçus et soldes", "Messages de l'école"],
    locations: ["Parents", "Élèves", "Titulaire"],
  },
  {
    eyebrow: "Direction scolaire",
    title: "Les écoles gagnent du temps sur la gestion quotidienne.",
    copy:
      "Inscriptions, classes, enseignants, discipline et finances restent organisés dans un même outil, adapté aux réalités des établissements locaux.",
    image: "assets/img/marketer/marketer.png",
    imageAlt: "Pilotage administratif EviveSoma",
    grayscale: true,
    stat: "1",
    statLabel: "Espace unifié",
    points: ["Dossiers centralisés", "Classes organisées", "Rapports rapides"],
    locations: ["Préfecture", "Direction", "Secrétariat"],
  },
  {
    eyebrow: "Communication école-famille",
    title: "Les annonces importantes arrivent vite aux bonnes personnes.",
    copy:
      "Retards, réunions, résultats, frais à payer et informations urgentes peuvent être partagés clairement entre l'école et les responsables.",
    image: "assets/img/validation/validation.png",
    imageAlt: "Communication entre école et famille",
    stat: "SMS",
    statLabel: "Infos utiles",
    points: ["Notifications", "Réunions parents", "Suivi des incidents"],
    locations: ["Familles", "Éducateurs", "Administration"],
  },
];

const insightItems = [
  "Tableau de bord parent clair et mobile",
  "Suivi scolaire et financier centralisé",
  "Communication école-famille plus rapide",
  "Consultation des résultats et bulletins en ligne",
  "Suivi des présences et absences des élèves",
  "Notifications importantes envoyées en temps réel",
  "Paiement des frais avec historique accessible",
  "Accès sécurisé aux informations scolaires",
  "Meilleure organisation administrative de l’école",
  "Plateforme moderne adaptée aux réalités des écoles",
  "Accès rapide aux informations de chaque enfant",
  "Suivi des devoirs, cours et activités scolaires",
  "Historique complet des paiements et soldes",
  "Consultation des horaires et programmes scolaires",
  "Partage simplifié des annonces et communications",
  "Réduction des pertes d’informations administratives",
  "Suivi solaire plus transparent pour les parents",
  "Gestion scolaire plus professionnelle et connectée",
  "Accès à la plateforme partout et à tout moment",
  "Centralisation des données scolaires de l’établissement",
  "Amélioration de la confiance entre l’école et les familles",
  "Gain de temps pour les parents et le personnel scolaire",
];

class Design extends Component {
  state = {
    activeSlide: 0,
  };

  componentDidMount() {
    this.heroTimer = window.setInterval(this.showNextSlide, 6200);
  }

  componentWillUnmount() {
    window.clearInterval(this.heroTimer);
  }

  setSlide = (activeSlide) => {
    window.clearInterval(this.heroTimer);
    this.setState({ activeSlide });
    this.heroTimer = window.setInterval(this.showNextSlide, 6200);
  };

  showNextSlide = () => {
    this.setState((state) => ({
      activeSlide: (state.activeSlide + 1) % heroSlides.length,
    }));
  };

  showPreviousSlide = () => {
    this.setState((state) => ({
      activeSlide: (state.activeSlide - 1 + heroSlides.length) % heroSlides.length,
    }));
  };

  render() {
    var user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : false;
    const slide = heroSlides[this.state.activeSlide];

    return (
      <section className="evive-hero-section" id="top">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 text-lg-start text-center">
              <div className="evive-hero-copy-slider" key={`copy-${this.state.activeSlide}`}>
                <span className="landing-eyebrow"><FeatherIcon icon="zap" size={14} />{slide.eyebrow}</span>
                <h1>{slide.title}</h1>
                <p className="evive-hero-copy">{slide.copy}</p>
              </div>
              <div className="evive-hero-points">
                {slide.points.map((point) => (
                  <span key={point}>
                    <FeatherIcon icon="check-circle" size={17} /> {point}
                  </span>
                ))}
              </div>
              <div className="evive-hero-actions">
                {user !== false && (
                  <a className="btn evive-primary-btn" aria-current="page" href="#profile">
                    Voir le suivi <FeatherIcon icon="arrow-right" size={17} />
                  </a>
                )}
                {user === false && (
                  <button className="btn evive-primary-btn" type="button" data-bs-toggle="modal" data-bs-target="#popupLogin">
                    Accéder à mon espace <FeatherIcon icon="arrow-right" size={17} />
                  </button>
                )}
                <a className="evive-secondary-link" href="#support">Découvrir les services <FeatherIcon icon="chevron-down" size={16} /></a>
              </div>
              <div className="evive-hero-slide-controls" aria-label="Navigation des slides">
                <button type="button" onClick={this.showPreviousSlide} aria-label="Slide précédent">
                  <FeatherIcon icon="chevron-left" size={18} />
                </button>
                <div className="evive-hero-dots">
                  {heroSlides.map((item, index) => (
                    <button
                      key={item.title}
                      type="button"
                      className={index === this.state.activeSlide ? "active" : ""}
                      onClick={() => this.setSlide(index)}
                      aria-label={`Afficher le slide ${index + 1}`}
                      aria-current={index === this.state.activeSlide ? "true" : undefined}
                    />
                  ))}
                </div>
                <button type="button" onClick={this.showNextSlide} aria-label="Slide suivant">
                  <FeatherIcon icon="chevron-right" size={18} />
                </button>
              </div>
              <div className="evive-local-tags" aria-label="Contextes scolaires">
                {slide.locations.map((location) => (
                  <span key={location}>{location}</span>
                ))}
              </div>
              <div className="evive-insight-slider" aria-label="Points forts EviveSoma">
                <div
                  className="evive-insight-track"
                  style={{
                    "--insight-duration": `${insightItems.length * 3}s`,
                    "--insight-offset": `-${(insightItems.length - 1) * 42}px`,
                    "--insight-steps": insightItems.length - 1,
                  }}
                >
                  {insightItems.map((item) => (
                    <span key={item}>{item}</span>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className={`evive-hero-visual-card${slide.grayscale ? " evive-hero-visual-grayscale" : ""}`}
                key={`visual-${this.state.activeSlide}`}
              >
                <div className="evive-visual-label">
                  <span className="evive-live-dot"></span>
                  Espace scolaire connecté
                </div>
                <img
                  className={`img-fluid${slide.grayscale ? " evive-grayscale-image" : ""}`}
                  src={slide.image}
                  alt={slide.imageAlt}
                />
                <div className="evive-floating-stat">
                  <strong>{slide.stat}</strong>
                  <span>{slide.statLabel}</span>
                </div>
                <div className="evive-visual-proof">
                  <FeatherIcon icon="shield" size={16} />
                  <span>Données sécurisées</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Design;
